export default __webpack_public_path__ + "static/media/Risque-Regular.3bda1522.ttf";